//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import { isLink } from '@/helpers/util';

export default {
  name: 'DpTreeViewRow',
  props: {
    data: { type: Object, default: null },
    columns: { type: Array, default: null, required: true },
    selection: { type: Array, default: () => [] },
    locked: { type: Boolean, default: false },
  },
  computed: {
    isSelected() {
      return this.selection.includes(this.data.$id);
    },
    idPadding() {
      const { $tableMeta: { hasChildren, treeDepth } } = this.data;
      let padding = treeDepth * 16;
      if (!hasChildren) {
        padding += 16;
      }
      return padding;
    },
    iconRotation() {
      const { $tableMeta: { expanded } } = this.data;
      return expanded ? 90 : 0;
    },
  },
  methods: {
    async toggleExpansion() {
      const { $tableMeta } = this.data;
      if (!$tableMeta.hasChildren) return;

      if ($tableMeta.expanded) {
        this.$emit('contract', this.data);
      } else {
        this.$emit('expand', this.data);
      }
    },
    getColumnStyle(column) {
      const { width } = column;
      if (!width) {
        return null;
      }
      return {
        flex: `0 0 ${width}`,
      };
    },
    getKpiState(kpiData) {
      if (!kpiData) return 'loading';
      if (kpiData.empty) return 'empty';
      return kpiData.level0 || null;
    },
    format(data, column) {
      const propertyData = data[column.property];
      if (column.date && propertyData !== null && propertyData !== undefined) {
        const m = moment(propertyData);
        if (!m.isValid()) { return propertyData; }
        return m.toDate().toLocaleString();
      }
      return propertyData;
    },
    getContent(data, column) {
      return this.format(data, column);
    },
    isLink(data, column) {
      return isLink(this.getContent(data, column));
    },
    handleClick(ev) {
      const { hasChildren, placeholder } = this.data.$tableMeta;
      if (hasChildren || placeholder) {
        return;
      }
      this.$emit('select-device', { ev, device: this.data.$id });
    },
  },
};
